import Yup from 'common/components/CopyMagic/shared/configureYup';

const TOPIC_MIN_LENGTH = 3;
const TOPIC_MAX_LENGTH = 1000;
export const promptSchema = Yup.object().shape({
  topic: Yup.string().trim().min(TOPIC_MIN_LENGTH).max(TOPIC_MAX_LENGTH).required(),
});

const CHAT_MIN_LENGTH = 3;
export const CHAT_MAX_LENGTH = 2500;
export const chatSchema = Yup.object().shape({
  topic: Yup.string().trim().min(CHAT_MIN_LENGTH).max(CHAT_MAX_LENGTH).required(),
});

const POST_TITLE_MIN_LENGTH = 1;
const POST_TITLE_MAX_LENGTH = 200;
export const postTitleSchema = Yup.string()
  .trim()
  .min(POST_TITLE_MIN_LENGTH)
  .max(POST_TITLE_MAX_LENGTH)
  .required();

const POST_BODY_MIN_LENGTH = 1;
const POST_BODY_LENGTH = 300;
export const postBodySchema = Yup.string()
  .trim()
  .min(POST_BODY_MIN_LENGTH)
  .max(POST_BODY_LENGTH)
  .required();

const CATEGORY_MIN_LENGTH = 1;
const CATEGORY_MAX_LENGTH = 140;
export const categoryTitleSchema = Yup.string()
  .trim()
  .min(CATEGORY_MIN_LENGTH)
  .max(CATEGORY_MAX_LENGTH)
  .required();

export const contentAssistantSchema = Yup.string().trim().required();

export const headlineAssistantSchema = Yup.string().trim().required();
